import { Component, OnInit } from '@angular/core';
import { ComplaintService } from '../../../services/complaint.service';

@Component({
  selector: 'app-complaints',
  templateUrl: './complaints.component.html',
  styleUrls: ['./complaints.component.css']
})
export class ComplaintsComponent implements OnInit {
  complaints: any[] = [];
  loading = false;
  selectedComplaint: any = null;
  updatingStatus: number | null = null;

  constructor(private cs: ComplaintService) { }

  ngOnInit() {
    this.load();
  }

  load() {
    this.loading = true;
    this.cs.listComplaints().subscribe({
      next: (res) => {
        this.loading = false;
        this.complaints = res.complaints || [];
      },
      error: () => this.loading = false
    });
  }

  updateStatus(id: number, status: string) {
    this.updatingStatus = id;
    this.cs.updateComplaint(id, { status }).subscribe({
      next: () => {
        this.updatingStatus = null;
        this.load();
      },
      error: () => this.updatingStatus = null
    });
  }

  selectComplaint(complaint: any) {
    this.selectedComplaint = this.selectedComplaint?.id === complaint.id ? null : complaint;
  }

  getPriorityColor(priority: string): string {
    switch (priority.toLowerCase()) {
      case 'high': return 'bg-red-100 text-red-700 border-red-200';
      case 'medium': return 'bg-amber-100 text-amber-700 border-amber-200';
      case 'low': return 'bg-emerald-100 text-emerald-700 border-emerald-200';
      default: return 'bg-slate-100 text-slate-700 border-slate-200';
    }
  }

  getStatusColor(status: string): string {
    switch (status.toLowerCase()) {
      case 'pending': return 'bg-amber-100 text-amber-700';
      case 'resolved': return 'bg-emerald-100 text-emerald-700';
      case 'rejected': return 'bg-red-100 text-red-700';
      default: return 'bg-slate-100 text-slate-700';
    }
  }
}
